// import Svg from "@/assets/illustrations/smbjm-skor-utbk-check.svg";
import FormHeader from "@/components/FormHeader"
import InputError from "@/components/InputError"
import Modal from "@/components/Modal"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import api from "@/lib/axios"
import { AxiosError } from "axios"
import { Loader2 } from "lucide-react"
import { useState } from "react"
import toast from "react-hot-toast"
import { IoWarning } from "react-icons/io5"
import { MdFactCheck } from "react-icons/md"
import { useMutation } from "@tanstack/react-query"
import { useNavigate } from "react-router-dom"

type CheckStatusUtbkState = {
  no_utbk: string
  nisn: string
}

const checkStatusUTBK = async (form: CheckStatusUtbkState) => {
  const response = await api.post("/siswa/penerimaan/smbjm/check-status-utbk", {
    ...form,
  })

  return response.data
}

export default function CheckStatusUtbkPage() {
  const navigate = useNavigate()
  const [form, setForm] = useState<CheckStatusUtbkState>({
    no_utbk: "",
    nisn: "",
  })
  const [showAlert, setShowAlert] = useState(false)

  const { mutate, isPending, error } = useMutation({
    mutationFn: checkStatusUTBK,
    onSuccess: (data) => {
      navigate("/penerimaan/smbjm")
      toast.success(data?.message || "Success.")
    },
    onError: (
      error: AxiosError<{ message?: string; errors?: Record<string, string[]> }>
    ) => {
      if (
        error.status === 404 ||
        error.response?.data.message?.startsWith("Bukan") ||
        error.response?.data.message?.startsWith("NIK")
      ) {
        setShowAlert(true)
      }

      const err = error as AxiosError<{
        message?: string
        errors?: Record<string, string[]>
      }>
      const errorMessage =
        err.response?.data?.message || "An unexpected error occurred."
      toast.error(errorMessage)
    },
  })

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    mutate(form)
  }

  return (
    <main className="mt-32 min-h-[80vh] flex gap-10">
      {/* <section className="flex-1 lg:block hidden">
        <img src={Svg} alt="check-status-utbk" width={500} />
      </section> */}
      <section className="flex-1 lg:max-w-[50%] mx-auto">
        <form onSubmit={handleSubmit} className="flex flex-col gap-y-3">
          <FormHeader title="Cek Status UTBK" icon={<MdFactCheck />} />
          <div>
            <Label>Nomor UTBK</Label>
            <Input
              minLength={12}
              maxLength={12}
              required
              placeholder="Ketik nomor utbk..."
              value={form.no_utbk}
              onChange={(event) =>
                setForm((prev) => ({ ...prev, no_utbk: event.target.value }))
              }
            />
            <InputError
              text={error?.response?.data.errors?.no_utbk?.join(",")}
            />
          </div>
          <div>
            <Label>NISN</Label>
            <Input
              minLength={10}
              maxLength={10}
              required
              placeholder="Ketik nisn..."
              value={form.nisn}
              onChange={(event) =>
                setForm((prev) => ({ ...prev, nisn: event.target.value }))
              }
            />
            <InputError text={error?.response?.data.errors?.nisn?.join(",")} />
          </div>
          <Button className="mt-3 flex items-center gap-3" disabled={isPending}>
            {isPending ? (
              <>
                <Loader2 className="w-4 h-4 mr-1 animate-spin" />
                Processing...
              </>
            ) : (
              "Kirim"
            )}
          </Button>
        </form>
      </section>

      <Modal show={showAlert} onClose={() => setShowAlert(false)}>
        <IoWarning size={50} className="mx-auto" />
        <div className="mt-5 p-3 rounded-xl border border-red-500 bg-red-50 text-red-500">
          {error?.response?.data.message?.startsWith("NIK") ? (
            <p>{error?.response?.data.message}</p>
          ) : (
            <p>
              Maaf data UTBK SNBT yang anda masukan {new Date().getFullYear()}{" "}
              tidak ditemukan di pusat.
            </p>
          )}
        </div>
      </Modal>
    </main>
  )
}
